// NOTE: Extract country/state codes from Google Places address_components.

function findComponent(components, type) {
    return (components || []).find((c) => Array.isArray(c.types) && c.types.includes(type));
}

export function parseGooglePlaceAddress(place) {
    const components = place?.address_components || [];
    const country = findComponent(components, 'country');
    const state = findComponent(components, 'administrative_area_level_1');

    return {
        country: country?.long_name || '',
        country_code: country?.short_name || '',
        state: state?.long_name || '',
        state_code: state?.short_name || '',
    };
}

export function hasPlaceLocationFields(location) {
    return Boolean(location?.country && location?.country_code);
}
